export default __webpack_public_path__ + "static/media/linkedin.c6633599.svg";